<div class="one" fxLayout="column" [formGroup]="matterAddressForm">
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlex="100">
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Title Ref(s) - Separate with commas</mat-label>
      <input matInput formControlName="LOTSTITLE" />
    </mat-form-field>
    <button matButton="filled" class="Split-Title" (click)="SplitTitleRefs()" [disabled]="isspiner">
      @if (isspiner) {
        <mat-spinner diameter="20"></mat-spinner>
      }
      Split Title Refs
    </button>
  </div>
  <div class="compact-fields">
    <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center" class="mb-8">
      <div fxFlex="19"><strong>Volume(s)</strong></div>
      <div fxFlex="19"><strong>Folio Id(s)</strong></div>
      <div fxFlex="19"><strong>Lots(s)</strong></div>
      <div fxFlex="19"><strong>Plan Type(s)</strong></div>
      <div fxFlex="19"><strong>Plan No(s)</strong></div>
    </div>
    <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
      <mat-form-field
        appearance="outline"
        fxFlex="19"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.VOLUME),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.VOLUME),
        }"
      >
        <input matInput name="Volume" formControlName="VOLUME" />
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="19"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.FOLIOID),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FOLIOID),
        }"
      >
        <input matInput name="FoliId" formControlName="FOLIOID" />
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        fxFlex="19"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.LOTS),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.LOTS),
        }"
      >
        <input matInput name="Lots" formControlName="LOTS" />
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="19"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.PLANTYPE),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PLANTYPE),
        }"
      >
        <input matInput name="PlanType" formControlName="PLANTYPE" />
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="19"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.PLANNUMBER),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PLANNUMBER),
        }"
      >
        <input matInput name="PlanNo" formControlName="PLANNUMBER" />
      </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
      <mat-form-field
        appearance="outline"
        fxFlex="19"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.VOLUME2),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.VOLUME2),
        }"
      >
        <input matInput name="Volume" formControlName="VOLUME2" />
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="19"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.FOLIOID2),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FOLIOID2),
        }"
      >
        <input matInput name="FoliId" formControlName="FOLIOID2" />
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="19"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.LOT2),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.LOT2),
        }"
      >
        <input matInput name="Lots" formControlName="LOT2" />
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="19"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.PLANTYPE2),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PLANTYPE2),
        }"
      >
        <input matInput name="PlanType" formControlName="PLANTYPE2" />
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="19"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.PLANNUMBER2),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PLANNUMBER2),
        }"
      >
        <input matInput name="PlanNo" formControlName="PLANNUMBER2" />
      </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
      <mat-form-field
        appearance="outline"
        fxFlex="19"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.VOLUME3),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.VOLUME3),
        }"
      >
        <input matInput name="Volume" formControlName="VOLUME3" />
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="19"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.FOLIOID3),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FOLIOID3),
        }"
      >
        <input matInput name="FoliId" formControlName="FOLIOID3" />
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="19"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.LOT3),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.LOT3),
        }"
      >
        <input matInput name="Lots" formControlName="LOT3" />
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="19"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.PLANTYPE3),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PLANTYPE3),
        }"
      >
        <input matInput name="PlanType" formControlName="PLANTYPE3" />
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="19"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.PLANNUMBER3),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PLANNUMBER3),
        }"
      >
        <input matInput name="PlanNo" formControlName="PLANNUMBER3" />
      </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
      <mat-form-field
        appearance="outline"
        fxFlex="19"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.VOLUME4),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.VOLUME4),
        }"
      >
        <input matInput name="Volume" formControlName="VOLUME4" />
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="19"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.FOLIOID4),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FOLIOID4),
        }"
      >
        <input matInput name="FoliId" formControlName="FOLIOID4" />
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="19"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.LOT4),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.LOT4),
        }"
      >
        <input matInput name="Lots" formControlName="LOT4" />
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="19"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.PLANTYPE4),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PLANTYPE4),
        }"
      >
        <input matInput name="PlanType" formControlName="PLANTYPE4" />
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="19"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.PLANNUMBER4),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PLANNUMBER4),
        }"
      >
        <input matInput name="PlanNo" formControlName="PLANNUMBER4" />
      </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
      <mat-form-field
        appearance="outline"
        fxFlex="19"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.VOLUME5),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.VOLUME5),
        }"
      >
        <input matInput name="Volume" formControlName="VOLUME5" />
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="19"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.FOLIOID5),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FOLIOID5),
        }"
      >
        <input matInput name="FoliId" formControlName="FOLIOID5" />
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="19"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.LOT5),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.LOT5),
        }"
      >
        <input matInput name="Lots" formControlName="LOT5" />
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="19"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.PLANTYPE5),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PLANTYPE5),
        }"
      >
        <input matInput name="PlanType" formControlName="PLANTYPE5" />
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="19"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.PLANNUMBER5),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PLANNUMBER5),
        }"
      >
        <input matInput name="PlanNo" formControlName="PLANNUMBER5" />
      </mat-form-field>
    </div>
  </div>
  <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
    <mat-form-field
      appearance="outline"
      fxFlex="25"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.LOTSECTION),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.LOTSECTION),
      }"
    >
      <mat-label>Section</mat-label>
      <input matInput name="Section" formControlName="LOTSECTION" />
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="25"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.BLOCK),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.BLOCK),
      }"
    >
      <mat-label>Block</mat-label>
      <input matInput name="Block" formControlName="BLOCK" />
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="25"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.STAGENUMBER),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.STAGENUMBER),
      }"
    >
      <mat-label>Stage No</mat-label>
      <input matInput name="StageNo" formControlName="STAGENUMBER" />
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="25"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.REDEVELOPMENTNUMBER),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.REDEVELOPMENTNUMBER),
      }"
    >
      <mat-label>Redevelopment No</mat-label>
      <input name="RedevelopmentNo" matInput formControlName="REDEVELOPMENTNUMBER" />
    </mat-form-field>
  </div>
</div>
